import { create } from 'zustand';
import { Moment } from 'moment';

import { ESortOrder, EStatusStr, IManagementCustomDimension } from '@src/emp-3.0/types';
import { EPanelOpenMethod } from '@components/block-event-single/store';
import { DEFAULT_SELECT_VALUE } from '@src/emp-3.0/constants/management';
import { createSetState, removeInvalidSelectedList } from '@src/emp-3.0/utils/management';
import { IFrontendGeneratedFields } from '@src/emp-3.0/components/Management';

interface ISelectDimension extends IManagementCustomDimension, IFrontendGeneratedFields {}

interface IUseDimensionManagementStoreProps {
  openBulkAction: boolean;
  setOpenBulkAction: (openBulkAction: boolean) => void;
  operationMode: EPanelOpenMethod;
  setOperationMode: (operationMode: EPanelOpenMethod) => void;
  activeDimension?: ISelectDimension;
  setActiveDimension: (activeDimension?: ISelectDimension) => void;
  // multiple selection operation
  selectedList: ISelectDimension[];
  setSelectedList: (selectedList: ISelectDimension[]) => void;
  setRemoveInvalidSelectedList: (allSelectedList: ISelectDimension[]) => void;
  // search
  searchText: string;
  setSearchText: (searchText: string) => void;
  // sort
  sort: { key: string; order: number };
  setSort: (sort: { key: string; order: number }) => void;
  // filter condition
  showFilter: boolean;
  setShowFilter: (showFilter: boolean) => void;
  status: EStatusStr;
  setStatus: (status: EStatusStr) => void;
  category: string;
  setCategory: (category: string) => void;
  updateDate: Moment[];
  setUpdateDate: (updateDate: Moment[]) => void;
  deployDate: Moment[];
  setDeployDate: (deployDate: Moment[]) => void;
  createdBy: string;
  setCreatedBy: (createdBy: string) => void;
  updatedBy: string;
  setUpdatedBy: (updatedBy: string) => void;
  // reset
  resetFilter: () => void;
  resetStore: () => void;
}

export const useDimensionManagementStore = create<IUseDimensionManagementStoreProps>((set) => ({
  openBulkAction: false,
  operationMode: EPanelOpenMethod.VIEW,
  activeDimension: undefined,

  setOpenBulkAction: createSetState(set, 'openBulkAction'),
  setOperationMode: createSetState(set, 'operationMode'),
  setActiveDimension: createSetState(set, 'activeDimension'),

  // multiple selection operation
  selectedList: [],
  setSelectedList: createSetState(set, 'selectedList'),
  setRemoveInvalidSelectedList: removeInvalidSelectedList(set),

  // search
  searchText: '',
  setSearchText: createSetState(set, 'searchText'),

  // sort
  sort: { key: '', order: ESortOrder.NORMAL },
  setSort: createSetState(set, 'sort'),

  // filter condition
  showFilter: false,
  status: EStatusStr.ALL,
  category: DEFAULT_SELECT_VALUE,
  updateDate: [],
  deployDate: [],
  createdBy: 'All',
  updatedBy: 'All',

  setShowFilter: createSetState(set, 'showFilter'),
  setStatus: createSetState(set, 'status'),
  setCategory: createSetState(set, 'category'),
  setUpdateDate: createSetState(set, 'updateDate'),
  setDeployDate: createSetState(set, 'deployDate'),
  setCreatedBy: createSetState(set, 'createdBy'),
  setUpdatedBy: createSetState(set, 'updatedBy'),

  // reset
  resetFilter: () =>
    set(() => ({
      status: EStatusStr.ALL,
      category: DEFAULT_SELECT_VALUE,
      updateDate: [],
      deployDate: [],
      createdBy: 'All',
      updatedBy: 'All',
    })),

  resetStore: () =>
    set(() => ({
      operationMode: EPanelOpenMethod.VIEW,
      activeDimension: undefined,
      selectedList: [],
      searchText: '',
      sort: { key: '', order: ESortOrder.NORMAL },
      showFilter: false,
      status: EStatusStr.ALL,
      category: DEFAULT_SELECT_VALUE,
      updateDate: [],
      deployDate: [],
      createdBy: 'All',
      updatedBy: 'All',
    })),
}));
